// Validation utility for required fields based on schema

// Demo Info required fields (based on business logic)
export const DEMO_REQUIRED_FIELDS = {
  dateOfMeeting: 'Meeting date is required',
  meetingMode: 'Meeting mode is required',
  meetingStatus: 'Meeting status is required'
};

// Evaluation/Pilot required fields (based on schema)
export const PILOT_REQUIRED_FIELDS = {
  // No schema-required fields, but business logic requirements
};

// Closed Won required fields (based on schema)
export const CLOSED_WON_REQUIRED_FIELDS = {
  dealValue: 'Deal value is required'
};

export const validateDemoInfo = (demoInfo) => {
  const errors = {};
  
  // Required fields validation
  if (!demoInfo.dateOfMeeting) {
    errors.dateOfMeeting = DEMO_REQUIRED_FIELDS.dateOfMeeting;
  }
  
  if (!demoInfo.meetingMode) {
    errors.meetingMode = DEMO_REQUIRED_FIELDS.meetingMode;
  }
  
  if (!demoInfo.meetingStatus) {
    errors.meetingStatus = DEMO_REQUIRED_FIELDS.meetingStatus;
  }
  
  return errors;
};

export const validateEvaluationPilot = (pilotInfo) => {
  const errors = {};
  
  // Based on EvaluationPilot schema - only 'lead' is required, but it's auto-populated
  // Add business logic requirements
  if (!pilotInfo.pilotStartDate && pilotInfo.pilotStatus === 'In Progress') {
    errors.pilotStartDate = 'Pilot start date is required when status is In Progress';
  }
  
  if (!pilotInfo.pilotScope && pilotInfo.pilotStatus !== 'Planning') {
    errors.pilotScope = 'Pilot scope is required';
  }
  
  return errors;
};

export const validateClosedWon = (wonInfo) => {
  const errors = {};
  
  // Based on ClosedWon schema - 'lead' and 'dealValue' are required
  if (!wonInfo.dealValue || wonInfo.dealValue <= 0) {
    errors.dealValue = CLOSED_WON_REQUIRED_FIELDS.dealValue;
  }
  
  return errors;
};

export const validateStatusHistory = (historyData) => {
  const errors = {};
  
  // Based on statusHistory schema - description is commonly required
  if (!historyData.description || historyData.description.trim() === '') {
    errors.description = 'Description is required';
  }
  
  return errors;
};

export const hasValidationErrors = (errors) => {
  return Object.keys(errors).length > 0;
};

export const getErrorMessage = (errors, fieldName) => {
  return errors[fieldName] || '';
};

// Helper functions to check if field is required
export const isDemoFieldRequired = (fieldName) => {
  return Object.keys(DEMO_REQUIRED_FIELDS).includes(fieldName);
};

export const isPilotFieldRequired = (fieldName) => {
  return Object.keys(PILOT_REQUIRED_FIELDS).includes(fieldName);
};

export const isClosedWonFieldRequired = (fieldName) => {
  return Object.keys(CLOSED_WON_REQUIRED_FIELDS).includes(fieldName);
};